<section class="claim-item">
    <div class="claim-item__container">
        <div class="claim-item__title">
            <div class="h3">{{ dossier.aard_schadegeval_omschrijving }}</div>
            <p>{{ dossier.schadedatum | dateFormat: "LL" }} om {{ dossier.schadetijdstip | time }} uur</p>
        </div>

        <div class="claim-item__handler" *ngIf="isLegalsharedBehandelaar">
            <img
                class="image"
                width="113"
                src="/assets/default-image-1x1.png"
                lazyLoad="/assets/shared/logos/legal-shared.png"
                alt="LegalShared B.V. inzake InShared (X)"
            />
        </div>

        <div class="claim-item__handler" *ngIf="isDasBehandelaar">
            <img
                class="image"
                width="50"
                src="/assets/default-image-1x1.png"
                lazyLoad="/assets/shared/logos/das-logo.png"
                alt="DAS Nederlandse Rechtsbijstand Verzekeringsmaatschappij N.V."
            />
        </div>

        <div class="claim-item__handler" *ngIf="isSarBehandelaar">
            <img
                class="image"
                width="284"
                src="/assets/default-image-1x1.png"
                lazyLoad="/assets/shared/logos/logo-achmea_rechtsbijstand.png"
                alt="Stichting Achmea Rechtsbijstand"
                title="Stichting Achmea Rechtsbijstand"
            />
        </div>
    </div>
    <div class="claim-item__actions">
        <p>
            Details van uw schadeclaim
            <a href="#" (click)="navigateTo()" *ngIf="dossier.pg_status !== 'Open'" class="btn btn--more">
                toon
                <svg class="svg-icon svg-icon--xs">
                    <use href="assets/icons-ui.svg#rechts-open"></use>
                </svg>
            </a>
        </p>
        <button
            class="claim-item__action"
            *ngIf="dossier.aantal_acties > 0 && dossier.pg_status === 'Open'"
            (click)="navigateTo(activePanel.PendingActionsPanel)"
        >
            Openstaande acties
            <span class="text-indicator text-indicator--pink-inverted">{{ dossier.aantal_acties }}</span>
        </button>
    </div>
    <div class="claim-item__actions" *ngIf="dossier.pg_status === 'Open'">
        <button class="claim-item__action" (click)="navigateTo(activePanel.InboxPanel)">Postvak in</button>
        <button
            *ngIf="!isDasBehandelaar && !isSarBehandelaar"
            class="claim-item__action"
            (click)="navigateTo(activePanel.AppointmentPanel)"
        >
            Afspraak
        </button>
        <button
            *ngIf="!isDasBehandelaar && !isSarBehandelaar"
            class="claim-item__action"
            (click)="navigateTo(activePanel.InvolvedPartyPanel)"
        >
            Betrokkenen
        </button>
        <button
            *ngIf="!isDasBehandelaar && !isSarBehandelaar"
            class="claim-item__action"
            (click)="navigateTo(activePanel.PhotoPanel)"
        >
            Foto's
        </button>
        <button
            *ngIf="!isDasBehandelaar && !isSarBehandelaar"
            class="claim-item__action"
            (click)="navigateTo(activePanel.PaperworkPanel)"
        >
            Documenten
        </button>
    </div>
</section>
